module.exports = "#wrapper {\n  padding-left: 0; }\n\n#page-wrapper {\n  width: 100%;\n  min-height: 100vh;\n  background-color: white; }\n\n@media (min-width: 768px) {\n  #wrapper {\n    padding-left: 100px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/com/app/app.scss
// module id = ./src/app/com/app/app.scss
// module chunks = main